import React, { useEffect, useState } from 'react'
import './searchbox.css'
import searchIcon from '../assets/searchIcon.svg'
import CloseIcon from '@mui/icons-material/Close'

interface SearchBoxProps {
  searchVal: string
  setSearchVal: (val: string) => void
  classes?: string
  parameters?: [] | string
  performAction: () => void
  emptyEnterFallback: () => void
  placeholder?: string
  sx?: React.CSSProperties
  containerStyle?: React.CSSProperties
  immediate?: boolean
  inputStyle?: React.CSSProperties
}

const SearchBox = (props: SearchBoxProps): JSX.Element => {
  const [isInputEmpty, setIsInputEmpty] = useState(true)
  const triggerSearch = (): void => {
    if (props.performAction !== undefined && typeof props.performAction === 'function' && props.searchVal !== '') {
      props.performAction()
    } else if (props.searchVal === '') {
      props.emptyEnterFallback()
    }
  }
  const handleKeyEnter = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === 'Enter') {
      triggerSearch()
    }
  }

  useEffect(() => {
    if (props.immediate !== undefined && props.immediate) {
      triggerSearch()
    }
  }, [props.searchVal])

  // istanbul ignore next
  const handleClearInput = (): void => {
    props.setSearchVal('') // Clear the input
    setIsInputEmpty(true)
    props.emptyEnterFallback()
  }

  return (
    <div style={{ margin: '10px 17px', ...props.containerStyle }} className={`custom-search-box-component ${props.classes !== undefined ? props.classes : ''}`}>
      <div className='custom-search-box' style={props.sx !== undefined ? props.sx : {}}>
        <i className='search-box-icon-img'><img className='search-icon' src={searchIcon} /></i>
        <input data-testid='search-box-input' className='search-box-input' style={props.inputStyle}
          onChange={(e) => {
            props.setSearchVal(e.target.value)
            setIsInputEmpty(e.target.value === '')
          }}
          placeholder={props.placeholder !== undefined ? props.placeholder : 'Search using Serial Number, Asset Name, Tag'}
          onKeyDown={handleKeyEnter}
          value={props.searchVal} />
        <span className='search-cross-bar'>{!isInputEmpty && (<CloseIcon onClick={handleClearInput}/>)}</span>
      </div>
    </div>
  )
}

export default SearchBox
